export default __webpack_public_path__ + "static/media/LinkedinIcon.b24321fe.svg";